export default "__VITE_ASSET__BOj8g$dJ__"